// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4F426A, #43426A, #426A67, #6A4255, #180C27, #071821,  #426A65, #6A4242",
  firstName: "Rokas",
  middleName: "",
  lastName: "Kazlauskis",
  message: " I enjoy solving problems using my computer ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/Ruoks",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/rokas-kazlauskis/",
    },
    {
      image: "fa-twitter",
      url: "https://twitter.com/KazlauskisRokas",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/ProfilePicture.jpeg"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/ProfilePicture2.png"),
  imageSize: 375,
  message: "My name is Rokas Kazlauskis, I am Software engineer with strong development, analytical, and research skills. Have knowledge of computer and software engineering, electronics engineering, product design, and robotics. Adept at communicating with peers and customers, and presenting before large groups. Possess strong problem-solving skills. Proven ability to achieve goals as part of a team and independently.",
  resume: require("../editable-stuff/Resume.pdf"),
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: false,
  heading: "Recent Projects",
  gitHubUsername: "Ruoks", //i.e."johnDoe12Gh"
  reposLength: 4,
  specificRepos: [],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    { 
      img: require("../editable-stuff/ProfilePicture.png"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/ProfilePicture.png"), 
      label: "Second slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "C#", value: 90 },
    { name: "SQL", value: 60 },
    { name: "Data Structures", value: 75 },
    { name: "JavaScript", value: 30 },
    { name: "React", value: 30 },
    { name: "HTML/CSS", value: 55 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message: "I'm always up for a new challanges and opportunities. If you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "r.j.kazlauskis@gmail.com"
};

const contactMe = {
  show: false,
  heading: "Get In Touch",
};

const projects = {
  show: true,
  heading: "Projects",
};

const experiences = {
  show: true,
  heading: "Experiences",
  imageHeight: 540, 
  imageWidth: 130,
  data: [
    {
      role: 'Business System Developer',
      companylogo: require('../assets/img/RHN.png'),
      date: 'April 2022 – Present',
    },
    {
      role: 'Software Engineer',
      companylogo: require('../assets/img/AstechProjects.png'),
      date: 'July 2019 – April 2022',
    },
    {
      role: 'Software and Electronics Engineer',
      companylogo: require('../assets/img/Cheyney.jpg'),
      date: 'November 2016 – June 2019',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences, contactMe, projects };
